import React from "react";
import { Button, Result } from "@version2/ui-package";
import { pages } from "src/Consts/config";
import { getFeatureLabel, type AppFeatureKey } from "src/Services/feature_access";

type FeatureNotAvailableProps = {
  featureKey?: AppFeatureKey;
};

const FeatureNotAvailable = ({ featureKey }: FeatureNotAvailableProps) => {
  const featureLabel = getFeatureLabel(featureKey);

  return (
    <div style={{ maxWidth: 720, margin: "80px auto", padding: "0 16px" }}>
      <Result
        status="warning"
        title="Feature unavailable"
        subTitle={`${featureLabel} is currently not available.`}
        extra={
          <Button type="primary" href={pages.HOME_PAGE.url}>
            Go to Home
          </Button>
        }
      />
    </div>
  );
};

export default FeatureNotAvailable;

